const cartItem = (key, prodcutTitle, variantTitle, url, image, quantity, price) =>
	`<div class="cart-item flex py-4 hover:bg-grey-200 transition-medium pl-4 overflow-hidden border-b border-grey-300"
      data-component="cart-item" data-key="${key}" >
      <a href="${url}" class="cart-item-image " >
        <img src="${image}" 
          alt="${prodcutTitle}" 
          class="absolute-fill object-contain"  />
      </a>
      <div class="flex-1 flex flex-col mx-4">
        <p class="mb-3" >${prodcutTitle}</p>
        ${variantTitle === null ? `` : `<p class="fs-sm text-grey-800">${variantTitle}</p>`}
        <div data-component="quantity" class="mt-auto" style="min-height: 36px; border: 1px solid #d1d5db; border-radius: 3px;" >
          <button data-action="decrement" >
            <svg class="svg-decrement" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><title>decrement</title><path fill="currentColor" d="M368 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path></svg>
          </button>
          <input type="number" name="quantity" value="${quantity}" min="1" 
            data-element="quantity-input" class="fs-sm" >
          <button data-action="increment">
            <svg class="svg-increment" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><title>increment</title><path fill="currentColor" d="M368 224H224V80c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V288h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path></svg>
          </button>
        </div>

      </div>
      <div class="flex flex-col justify-between items-end">
        <button class="pt-1 pr-4 pb-4 pl-2 "
          data-action="remove-item" >
          <svg class="svg-close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Close</title><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"></path></svg>
        </button>
        <p class="pr-4 pb-1">${price}</p>
      </div>
    </div>`.trim();

export { cartItem };
